
let colors = {
    blue: {
        primary: '#54a0ff',
        secondary: '#2e86de',
    },
    yellow: {
        primary: '#feca57',
        secondary: '#ff9f43',
    },
    black: {
        primary: '#353b48',
        secondary: '#000',
    },
    lightblue: {
        primary: '#48dbfb',
        secondary: '#0abde3',
    },
    green: {
        primary: '#1dd1a1',
        secondary: '#10ac84',
    },
    red: {
        primary: '#ff6b6b',
        secondary: '#ee5253',
    },
}
/*
colors = {
    blue: 'blue',
    yellow: 'yellow',
    black: 'black',
    lightblue: 'lightblue',
    green: 'green',
    red: 'red',
}
*/

/*
let Levels = [
    {
        layout: [
            [ 0 , 'h',  0 , 's',  0 ],
            ['a', 's', 'i', 'c', 'o'],
            [ 0 , 'h',  0 , 'a',  0 ],
            ['s', 'm', 'b', 'o', 'l'],
            [ 0 , 'y',  0 , 'l',  0 ],
        ],
        words: ['symbol', 'hash', 'social'],
        theme: 'number',
        colors: colors.blue
    },
    {
        layout: [
            ['w','r'],
            ['d','o'],
        ],
        words: ['word'],
        theme: 'word',
        colors: colors.red
    },
    {
        layout: [["l","i","l"],["a","n","v"],[0,"i",0],[0,"a",0],[0,"n",0]],
        words: ["nail","anvil"],
        theme: 'hammer',
        colors: colors.yellow
    },
    {
        layout: [[0,"t",0],["x","a","t"],["b",0,0],["d","e","t"],[0,0,"s"],["i","v","e"],[0,"n",0]],
        words: ["debt","tax","invest"],
        theme: 'money',
        colors: colors.green
    },
    {
        layout: [["k","s","s",0,0,0,0],["c",0,"e","u","i","q","e"],["o",0,"c",0,"n",0,"u"],["l","a","c",0,0,0,0]],
        words: ["unique","access","lock"],
        theme: 'key',
        colors: colors.yellow
    },
    {
        layout: [["e","n","y","i","g"],["r","e","t","p","n"],["s","c","t","o","p"],[0,0,"k",0,0],[0,"d","e","s",0]],
        words: ["screen","desktop","typing"],
        theme: 'computer',
        colors: colors.green
    },
    {
        layout: [[0,0,0,"t",0,0,0],[0,0,"g","a","n",0,0],[0,"b","e","p","n","e",0],["t","o","m","y","t","c","i"]],
        words: ["ancient","egypt","tomb"],
        theme: 'pyramid',
        colors: colors.yellow
    },
    {
        layout: [["k","a","e"],["d",0,"r"],["u","n","b"],[0,"o",0],["n","k","b"],["i",0,"n"],["l","r","o"],[0,"i",0],["l","a","j"],["i",0,"f"],["c","u","f"]],
        words: ["cuff","jail","link","iron","bound","break"],
        theme: 'chain',
        colors: colors.black
    },
    {
        layout: [["e","s",0,0,0,"t","f"],["i","c","x","e","g","m","i"],["r","e",0,0,0,"y","l"]],
        words: ["gym","lift","exercise"],
        theme: 'barbell',
        colors: colors.black
    },
    {
        layout: [["e","d"],["s","h"],["n","i"],["t","o"],["a","s"],[0,0],["d","o"],["u","l"]],
        words: ["astonished","loud"],
        theme: 'exclaim',
        colors: colors.blue
    },
    {
        layout: [["t",0,0,"t"],["u",0,0,"s"],["n","t","i","t"],[0,"e","w",0],[0,"k","l",0],[0,"c","o",0],[0,"o","o",0],[0,"s","t",0]],
        words: ["nut","socket","tool","twist"],
        theme: 'wrench',
        colors: colors.black
    },
    {
        layout: [[0,"n","e","s","e",0],[0,"e",0,0,"a",0],["g","g","g","n","c","t"],["g","a","i","l","a","i"],["a","k","c","r","p","u"],["b","a","p","a","i","s"]],
        words: ["airplane","packing","baggage","suitcase"],
        theme: 'luggage',
        colors: colors.blue
    },
    {
        layout: [["c","h","e","r","r","o","t"],["t",0,0,0,0,0,"c"],["e",0,0,"s",0,0,"o"],["r",0,"e","r","n",0,"d"],["t",0,0,"u",0,0,"y"],["s",0,0,0,0,0,"r"],["i","n","f","i","r","m","a"]],
        words: ["nurse","infirmary","stretcher","doctor"],
        theme: 'medic',
        colors: colors.red
    },
    {
        layout: [["r","m","e","e",0,0],["e","r","c","f","f","r"],["d","w","a","o",0,"e"],["i","n","g","i",0,"h"],["t","e","i","p","t","c"],["c","s","a","m",0,0]],
        words: ["cider","pitcher","steaming","coffee","warm"],
        theme: 'mug',
        colors: colors.yellow
    },
    {
        layout: [["g","n","t",0,0,"e"],[0,"i","a",0,"e","z"],[0,0,"l","e","r","b"],["c","l","g","n",0,0],["s","i",0,"l","i",0],["o",0,0,"o","o","c"]],
        words: ["cooling","oscillating","breeze"],
        theme: 'fan',
        colors: colors.lightblue
    },
    {
        layout: [[0,0,0,0,"o","c",0,0],[0,0,0,0,"e","t","o",0],[0,0,0,0,"s",0,0,"n"],[0,0,0,0,"i",0,0,0],[0,0,0,0,"d",0,0,0],[0,0,0,0,"j",0,0,0],[0,"z","r","e","l",0,0,0],["l","s","z","a","a",0,0,0],["c","a","s","g","c",0,0,0],[0,"e","n","i",0,0,0,0]],
        words: ["genre","jazz","classical","disco","note"],
        theme: 'music',
        colors: colors.black
    },
    {
        layout: [[0,"n","h","b","t",0],["p","u","u","c","k","e"],[0,0,0,0,0,0],["c","h","e","e","s","e"],[0,0,0,0,0,0],["l","d","i","n","e","r"],[0,"l","i","r","g",0]],
        words: ["grill","diner","ketchup","cheese","bun"],
        theme: 'hamburger',
        colors: colors.green
    },
    {
        layout: [[0,0,0,"m","i","p",0,0],[0,0,0,"i",0,"l",0,0],[0,0,0,"r","g","c",0,0],["r","o","t",0,"n",0,0,0],["l",0,"t","r","i","w","e","s"],["i","a","p",0,"a",0,0,0],[0,0,0,0,"h",0,0,0],[0,0,0,0,"s",0,0,0]],
        words: ["tailor","clip","sharp","trim","sewing"],
        theme: 'scissors',
        colors: colors.lightblue
    },
    {
        layout: [[0,"y",0,0,"e",0],[0,"t",0,0,"g",0],[0,"r",0,0,"a",0],["i","r","d","c","t","v"],["c","t","o","l","o","o"],["i","e","l","t","u","e"],[0,"t","c","e","l",0]],
        words: ["cord","electricity","outlet","voltage"],
        theme: 'plug',
        colors: colors.yellow
    },
    {
        layout: [[0,0,"h","o","r",0,0],[0,"i",0,0,0,"p",0],["t",0,"b",0,0,0,"w"],["c",0,0,"i",0,0,"a"],["i",0,0,0,"t",0,"l"],[0,"r",0,0,0,"r",0],[0,0,"t","s","e",0,0]],
        words: ["prohibit","restrict","law"],
        theme: 'ban',
        colors: colors.red
    },
    {
        layout: [[0,0,"n","l","i",0,0],[0,0,"i",0,"a",0,0],[0,0,"h","a","s",0,0],[0,0,0,"c",0,0,0],[0,0,"i","p","s",0,0],["e",0,0,"h",0,0,"y"],["o","r",0,"e",0,"u","o"],[0,"h","s","p","o","b",0],[0,0,0,"r",0,0,0]],
        words: ["shore","rope","ship","sail","buoy","chain"],
        theme: 'anchor',
        colors: colors.blue
    },
    {
        layout: [["t","n","a","s","n","o","c"],[0,0,"t",0,"r",0,0],[0,0,"e",0,"e",0,0],[0,0,"l",0,"t",0,0],[0,0,"c",0,"e",0,"i"],["c","i","r",0,"m","a","d"]],
        words: ["circle","diameter","constant"],
        theme: 'pi',
        colors: colors.green
    },
    {
        layout: [["e",0,"h",0,"c","h","i","n"],["l","o","w",0,"t","w","e","a"],[0,"o",0,0,"a","f","c","o"],[0,"b","l","n","i","l","t","a"]],
        words: ["fin","watch","blowhole","tail","ocean"],
        theme: 'whale',
        colors: colors.blue
    },
    {
        layout: [["n","i","t","i","n"],[0,"y","e","p",0],[0,"a","l","r",0],[0,"l","l","u",0],["p","s","b","p","e"],["i","d","g","p","a"],[0,0,"n",0,0],[0,0,"a",0,0],[0,0,"h",0,0]],
        words: ["display","paper","pin","hang","bulletin"],
        theme: 'thumbtack',
        colors: colors.red
    },
    // {
    //     layout: [[0,"t","y","p","i","l","p","e"],[0,"a","r","s","p","l",0,"e"],[0,"l","a","n","l","a","t","s"],[0,"e","p","i","b","r",0,0],[0,"c","r","o","e","h",0,0],[0,0,0,0,0,0,0,0],["w","e","r","b","p","o","t",0]],
    //     words: ["steep","pot","party","brew","porcelain","herbal","spill"],
    //     theme: 'tea',
    //     colors: colors.yellow
    // },
    {
        layout: [[0,0,0,"t",0,0,0],[0,0,"n","c","e",0,0],[0,"r","a","e","u","o",0],["s","e","l","l","e","r","r"],[0,"u",0,"d",0,"s",0],[0,"p",0,"a",0,"s",0],[0,"m",0,"r",0,"e",0],["c","a","g","p","r","o","f"]],
        words: ["campus","professor","learn","lecture","grade"],
        theme: 'university',
        colors: colors.red
    },
    {
        layout: [["l","h","c",0,0,0],["e",0,"a","p",0,0],["a","b","t","i","h",0],[0,"l","t","s","e","n"],[0,0,"a","r","w",0],[0,0,0,"o",0,0]],
        words: ["attach","label","ownership"],
        theme: 'tag',
        colors: colors.blue
    },
    {
        layout: [["r","s","t","e","r","o"],["e",0,0,0,0,"e"],["k",0,0,0,0,"o"],["a","p",0,0,"u","i"],["e","s",0,0,"a","d"]],
        words: ["audio","stereo","speaker"],
        theme: 'headphones',
        colors: colors.blue
    },
    {
        layout: [[0,0,"r",0,0],[0,0,"e",0,0],[0,0,"b",0,0],[0,0,"b",0,0],[0,0,"u",0,0],[0,0,"r",0,0],[0,0,"m",0,0],[0,"o","o","t",0],["r","t","b","e","l"],["h","a","t","o","i"]],
        words: ["toilet","bathroom","rubber"],
        theme: 'plunger',
        colors: colors.red
    },
    {
        layout: [[0,0,0,"i",0,0,0],[0,0,0,"w","n",0,0],[0,0,0,"g","t","d",0],[0,0,0,"t","s","a","m"],[0,0,0,"a",0,0,0],["p","r","r","o","b","a","t"],[0,"o","e","t","a","t",0]],
        words: ["regatta","port","boat","mast","wind"],
        theme: 'sailing',
        colors: colors.blue
    },
    {
        layout: [[0,"w","s","d","s",0],["e","n","u","u","l","c"],["t","u","g","o","n","u"],["s",0,"f","o",0,"o"],[0,0,"s","o",0,0],[0,0,"i","p",0,0]],
        words: ["poisonous","cloud","stew","fungus"],
        theme: 'mushroom',
        colors: colors.yellow
    },
    {
        layout: [[0,"c","i","e",0],["d","i",0,"n","e"],["e",0,0,0,"l"],["m",0,0,0,"o"],["e",0,0,0,"b"],["s","d","c","e","u"],["o","a","p",0,"s"],["n","l","v",0,"p"],["i","m",0,"i","a"],[0,"a","t","c",0]],
        words: ["dose","capsule","vitamin","medicine","placebo"],
        theme: 'pill',
        colors: colors.red
    },
    {
        layout: [["l","c","i",0,"i","c","e"],["a",0,"t","v","t",0,"r"],["o","p","e",0,"c","o","r"]],
        words: ["corrective","optical"],
        theme: 'glasses',
        colors: colors.lightblue
    },
    {
        layout: [["m",0,"s",0,"u",0],[0,"o",0,"q",0,"a"],["v",0,"p",0,"r",0],[0,"e",0,"m",0,"e"],["k",0,"n",0,"u",0],[0,"i",0,"g",0,"j"]],
        words: ["move","king","square","jump"],
        theme: 'checkers',
        colors: colors.red
    },
    {
        layout: [[0,"e","k","e","c","m",0],["r","a","c","k","n","e","t"],[0,"i","l","g","i","a",0],[0,0,"n","a","r",0,0],[0,0,0,"n",0,0,0]],
        words: ['ring', 'mine', 'karat', 'necklace'],
        theme: 'diamond',
        colors: colors.lightblue
    },
    {
        layout: [["m","i","a","w","o","r","r"],["e",0,0,0,0,0,"a"],["c",0,"b","u","l",0,"y"],["i",0,"e",0,"l",0,"c"],["t",0,"y","e","s",0,"a"],["c",0,0,0,0,0,"r"],["a","r","p","a","c","c","u"]],
        words: ["practice","accuracy","arrow","aim","bullseye"],
        theme: 'target',
        colors: colors.red
    },
    {
        layout: [[0,"a","y",0,"e","t",0],["l","n","r","e","h","i","s"],["e","i","f","t","c","n","t"],["m","a","h","i","a","d","e"],[0,"t","u","b","r","p",0],[0,"o","m",0,"a","s",0],[0,0,"e",0,"h",0,0]],
        words: ["bite","sharp","enamel","ache","mouth","dentist","fairy"],
        theme: 'tooth',
        colors: colors.lightblue
    },
    {
        layout: [["a","n","g","d","y","y","o"],["t","n","i","o","l","n","h"],["a",0,"u",0,"e",0,"p"],["n",0,"t",0,"m",0,"m"],["o",0,0,0,0,0,"y"],["s","d","n","a","r","g","s"]],
        words: ["grand","melody","symphony","sonata","tuning"],
        theme: 'piano',
        colors: colors.black
    },
    {
        layout: [["e",0,0,0,0,0],["l","s","t","y",0,0],["o","i","r","h","m","t"],["p","t","o","a","e","s"],["n",0,0,"w","v","a"],["u",0,0,0,0,0],["o",0,0,0,0,0],["c",0,0,0,0,0]],
        words: ["mast","wave","hoist","country","pole"],
        theme: 'flag',
        colors: colors.lightblue
    },
    {
        layout: [["s","p","s","r","d"],["e","i","s","y","a"],["t","l","a","n","e"],["o","t","l","v","i"],[0,"b","g","g",0],[0,0,"n",0,0],[0,0,"i",0,0],[0,0,"t",0,0],[0,"s","a","t",0]],
        words: ["bottle","vineyard","tasting","sip","glass"],
        theme: 'wine',
        colors: colors.red
    },
    {
        layout: [[0,0,"o","y","d",0,0],[0,0,"s","n","o",0,0],[0,0,"p","r","b",0,0],[0,0,0,"e",0,0,0],["p","r","i","m","a","t","e"],[0,0,0,"l",0,0,0],[0,0,0,"s",0,0,0],[0,0,"i","e","a",0,0],[0,0,"c",0,"m",0,0],[0,0,"e",0,"m",0,0],[0,"s","p",0,"a","m",0]],
        words: ["mammal","species","primate","person","body"],
        theme: 'human',
        colors: colors.green
    },
    {
        layout: [[0,"y","c","n","u","s",0],["p","e","l","o","t","e","o"],["o","a","n","i","c","t","r"],["n",0,0,"b",0,0,"p"],[0,0,0,"a",0,0,0],[0,0,0,"d",0,0,0],[0,0,0,"l",0,0,0],[0,0,"f","o",0,0,0]],
        words: ["canopy","foldable","sun","protection"],
        theme: 'umbrella',
        colors: colors.lightblue
    },
    {
        layout: [[0,"c","z",0],["n","i","l","l"],["e",0,0,"e"],["g",0,0,"c"],["r",0,0,"e"],["a",0,0,"r"],["c","h","w","i"]],
        words: ["charge","zinc","wire","cell"],
        theme: 'battery',
        colors: colors.green
    },
    {
        layout: [["r",0,0,"m"],["e","t","b","i"],["h",0,0,"l"],["g","i","g","c"],["f",0,0,"n"],["e","i","f","u"],["r",0,0,"r"]],
        words: ["firefighter","rung","climb"],
        theme: 'ladder',
        colors: colors.yellow
    },
    // {
    //     layout: [[0,"m","i",0,"w","t",0],["n","u","c","m","o","e","c"],["k","i","l","l","r","k","o"],[0,"s","a","s","r","s",0],[0,0,"c","k","a",0,0],[0,0,"o","n","l",0,0],[0,0,"e","t","e",0,0],[0,"t","e","l","u","n",0],["o","n","s","k","p","i","s"],["j","i","s","w","l","s","o"],[0,"j","a",0,"i","f",0]],
    //     words: ["fossil","socket","jaw","spine","skin","joint","marrow","skull","skeleton","calcium"],
    //     theme: 'bone',
    //     colors: colors.black
    // },
    {
        layout: [[0,0,"p","y",0,0],[0,0,"i","o",0,0],["e","l","h","f","w","a"],["b","s","r","h","i","f"],[0,0,"i","t",0,0],[0,0,"g","e",0,0],[0,0,"l","o",0,0],[0,0,"e","o",0,0],[0,0,"t","h",0,0]],
        words: ["theology","belief","worship","faith"],
        theme: 'religion',
        colors: colors.yellow
    },
    {
        layout: [[0,"s","e","e","o","r",0],["r","i","c","i","e","k","a"],["e","r","l","s","l","u","b"],[0,"t","t","l","n","f",0],[0,"t","u","e","a","t",0],[0,"u","l","l","e","s",0],[0,"b","o","r","g","y",0]],
        words: ["roll","gluten","slice","yeast","butter","flour","rise","bake"],
        theme: 'bread',
        colors: colors.yellow
    },
    {
        layout: [["t",0,"p",0,"n"],["i","z","h","u","e"],["l","b","b","q","e"],[0,"n","k","o",0],[0,"o","o","r",0],[0,"e","c","t",0],[0,"s","h","g",0],["k","i","i","n","k"],["c","h","w","a","p"]],
        words: ["pawn","check","bishop","blitz","rook","knight","queen"],
        theme: 'chess',
        colors: colors.yellow
    },
    // {
    //     layout: [[0,0,"l","e",0,0],[0,"b","l","m","r",0],[0,"t","a","a","f",0],[0,0,"i","e",0,0],[0,0,"l","n",0,0],[0,"e","p","a","s",0],[0,"g","s","l","y",0],["t","e","s","t","l","s"],["t","e","r","p","n","e"],["u","k","r","a","i","l"],[0,"i","r","a","p",0]],
    //     words: ["spare","gutter","alley","strike","spin","split","ball","lane","frame"],
    //     theme: 'bowling',
    //     colors: colors.red
    // },
    {
        layout: [[0,0,0,"b",0,0,0],[0,0,"r","m","n",0,0],[0,"y","o","i","i","t",0],["s","k","t","l","a","u","n"],[0,0,"a","c","o",0,0],[0,0,"v","n","m",0,0],[0,0,"e","w","y",0,0],[0,0,"l","o","l",0,0],[0,0,"e","d","f",0,0]],
        words: ["down","fly","sky","climb","elevator","mountain"],
        theme: 'up',
        colors: colors.lightblue
    },
    {
        layout: [[0,0,0,"l",0,0,0],["n",0,"r","e","n",0,"r"],["n","o","c","e","q","u","e"],["w","o","b","u","e","r","l"]],
        words: ["noble","crown","queen","ruler"],
        theme: 'royalty',
        colors: colors.yellow
    },
    {
        layout: [["a","l","k","c","a","r","c","y"],["w",0,"l",0,0,0,0,"e"],["e",0,"i",0,0,0,0,"n"],["c","u","b","l","d","d","e","m"],["a",0,0,0,0,"a",0,"i"],["l",0,0,0,0,"c",0,"h"],["p","e","r","i","f","f","a","c"]],
        words: ["build","fireplace","facade","wall","crack","chimney"],
        theme: 'brick',
        colors: colors.red
    },
    {
        layout: [[0,0,0,"b",0,0,0],[0,0,0,"u",0,0,0],[0,0,"s","h","r",0,0],[0,0,0,"m",0,0,0],[0,"s","a","p","l","e",0],[0,0,0,"i",0,0,0],["e","g","a","l","k","a","o"],[0,0,0,"o",0,0,0],[0,0,0,"f",0,0,0]],
        words: ["oak","foliage","sap","shrub","elm"],
        theme: 'tree',
        colors: colors.green
    },
    {
        layout: [[0,0,"n",0,0],[0,0,"m",0,0],[0,"w","e","a",0],[0,"e","t","r",0],["n","d","u","s","p"],["i","e","s","o","a"],["a","h","r","o","v"],[0,"t","o","f",0]],
        words: ["fountain","hose","stream","vapor","dew"],
        theme: 'water',
        colors: colors.blue
    },
    {
        layout: [[0,"e","r",0,"l","u",0],["o","d","t","o","o","s","o"],["w","o","a","d","n","v","l"],[0,"e","a","o","e","p",0],[0,0,"i","s","a",0,0],[0,0,0,"s",0,0,0]],
        words: ["passion","adore","soul","date","woo","love"],
        theme: 'heart',
        colors: colors.red
    },
    {
        layout: [["c","h","p","a","r","g","y"],["e",0,0,0,0,0,"l"],["i","d","i","v","t","i","p"],["t",0,"i",0,"l",0,"t"],["e","d","d","a","u",0,"i"],["m",0,"d",0,"m",0,"g"],["h","t","i","r","a","d","i"]],
        words: ["digit","arithmetic","graph","add","divide","multiply"],
        theme: 'calculator',
        colors: colors.red
    },
    {
        layout: [["t","s","i","t","e","w","e"],["u",0,0,"d",0,0,"i"],["o",0,0,"h",0,0,"v"],["a","s","s","g","s","u","e"],["l",0,0,"i",0,0,"n"],["g",0,0,"l",0,0,"n"],["e","m","a","r","f","p","a"]],
        words: ["frame","pane","sun","view","glass","light","outside"],
        theme: 'window',
        colors: colors.yellow
    },
    {
        layout: [[0,0,"g","e","t",0,0],[0,0,"r",0,0,0,0],["t","a","e","d","i","l","s"],[0,0,0,0,0,0,0],["i","c","e","e","t","o","s"],[0,"m","a","e","n","t",0]],
        words: ["ice","team","slide","target","stone"],
        theme: 'curling',
        colors: colors.blue
    },
    {
        layout: [["i",0,0,0,"u","t","r",0],["w","m",0,"a","u","o","c","t"],["s","l","s","a","l","m","o","n"],["l","g",0,"n","t","o","t","b"],["i",0,0,0,"d","i","a",0]],
        words: ["tuna","cod","gill","swim","bait","salmon","trout"],
        theme: 'fish',
        colors: colors.blue
    },
    {
        layout: [[0,0,"e",0,0],[0,"a","c","t",0],["p","s","e","a","u"],[0,"f",0,"l",0],[0,"f","t","n",0],[0,"o","t","o",0],[0,"e","u","r",0],["a","k","h","a","t"],["t",0,"s",0,"s"]],
        words: ["takeoff","space","astronaut","shuttle"],
        theme: 'rocket',
        colors: colors.red
    },
    {
        layout: [[0,0,"s","s","i","n","e",0,0],[0,"d","a","h","p","n","e","y",0],[0,"l","e","t","s","o","b","o",0],["e","i",0,0,"o",0,0,"o","k"],["t","a",0,0,"f",0,0,"o","o"],[0,"r","i","d",0,"k","t","p",0],[0,"n","o","e","e","s","t","s",0],[0,0,"t","l","a","e","a",0,0],[0,0,"p",0,"h",0,"t",0,0]],
        words: ["head","bone","pirate","skeleton","fossil","spooky","death","tattoo","spine"],
        theme: 'skull',
        colors: colors.black
    },
    {
        layout: [[0,"w","a","s","t","e",0],[0,0,0,0,0,0,0],["c","r","n","l","e","l","a"],[0,"a",0,"c",0,"s",0],[0,"e",0,"y",0,"o",0],[0,"t",0,"c",0,"p",0],[0,"t",0,"e",0,"s",0],[0,"l","i","r","i","d",0]],
        words: ["recycle","disposal","litter","waste","can"],
        theme: 'trash',
        colors: colors.black
    },
    {
        layout: [[0,"t",0,0,0,"a",0],["n","n","o","i","t","c","a"],["e",0,0,0,0,0,"v"],["v","u","l","e","k","a","y"],["d",0,"d",0,"e",0,"d"],["a","h","e","w","e","l","i"],["a",0,"c",0,"t",0,"o"],["d","y","s","e","d","a","h"]],
        words: ["date","holiday","vacation","day","advent","week","schedule"],
        theme: 'calendar',
        colors: colors.red
    },
    {
        layout: [[0,"e","l",0],[0,"i","f",0],[0,0,0,0],["c","a","e",0],[0,"i","t",0],[0,"m","n",0],[0,"m","u",0],[0,"k","o",0],["l","e","a","c"]],
        words: ["leak","file","communicate"],
        theme: 'information',
        colors: colors.blue
    },
    {
        layout: [[0,0,"m","r","e",0,0],[0,"g","i","e","l","l",0],[0,"n","c","i","g","e",0],[0,"o","o","h","n","p",0],[0,"m","u","n","i","a",0],["g","m","n","s","j","c","h"],[0,0,0,"g",0,0,0]],
        words: ["chapel","gong","jingle","summon","chime","ring"],
        theme: 'bell',
        colors: colors.yellow
    },
    {
        layout: [[0,0,"l","f","z","o",0,0],["o","m","i",0,0,"o","m","e"],["t",0,0,0,0,0,0,"r"],["o",0,0,"e","s",0,0,"u"],["h",0,0,"l","n",0,0,"s"],["p",0,0,0,0,0,0,"o"],["l","a","c","o","f","e","x","p"]],
        words: ["film","focal","zoom","lens","exposure","photo"],
        theme: 'camera',
        colors: colors.lightblue
    },
    {
        layout: [[0,0,"t","l","a","n","i"],[0,0,"c",0,0,0,"g"],["n","e","x","a","y",0,"i"],["i",0,0,0,"p",0,"r"],["w",0,0,0,"o","m","o"],["t",0,0,0,"u",0,0],["e","t","a","t","c",0,0]],
        words: ["original","copy","exact","mutate","twin"],
        theme: 'clone',
        colors: colors.blue
    },
    {
        layout: [[0,0,0,"f","a",0,0,0],[0,0,0,"l","h",0,0,0],[0,0,0,0,0,0,0,0],["e","a","a","m","s","y","l","p"],["t","r","p","e","u","l","t","i"],[0,0,0,0,0,0,0,0],[0,0,0,"o","r",0,0,0],[0,0,0,"z","e",0,0,0]],
        words: ["half","zero","multiply","separate"],
        theme: 'divide',
        colors: colors.lightblue
    },
    {
        layout: [[0,0,0,"c",0,0,0],[0,0,"k",0,"i",0,0],[0,"d",0,0,0,"l",0],["n",0,0,0,0,0,"r"],["e","a",0,0,0,"p","e"],["s","s","l",0,"l","t","t"],["t","m","e","a","i","e","l"],["s","a","p","m","a","l","f"]],
        words: ["lick","seal","stamp","mail","flap","letter","send"],
        theme: 'envelope',
        colors: colors.lightblue
    },
    {
        layout: [["p","a","y","t","b","e","d"],[0,0,0,0,0,0,0],["m","b","e","d","a","o","l"],["u",0,0,"r",0,"t","s"],["n","i","n","t","e","r","e"]],
        words: ["debt","interest","number","load","pay"],
        theme: 'credit card',
        colors: colors.lightblue
    },
    {
        layout: [[0,0,"s","m","k","i","n"],[0,0,"e","u","a","r","a"],[0,"z","d","s","e","r",0],[0,"t","u","y","t",0,0],["o","l","r","o","s","c","c"],["b","o","t","t","l","l",0],[0,0,"c","i","a",0,0],[0,"t","i","p",0,0,0],[0,"c","r",0,0,0,0],["l","e",0,0,0,0,0],["e",0,0,0,0,0,0]],
        words: ["electricity","storm","clap","bolt","zeus","rain","cloud","streak"],
        theme: 'lightning',
        colors: colors.yellow
    },
    {
        layout: [[0,"b","o","l","c",0],[0,"t",0,0,"t",0],[0,"e",0,0,"p",0],["s","r","e","l","e","k"],["u","e","u","n","k","c"],["s","f","c","s","a","i"],["a","t","s","h","r","e"],["r","s","y","p","l","i"]],
        words: ["pliers","pick","shackle","rusty","fasten","secure","bolt"],
        theme: 'lock',
        colors: colors.yellow
    },
    {
        layout: [[0,0,"l",0,0,0,0,0],[0,"t","n","a",0,0,0,0],["r","s","i","v","i",0,0,0],[0,"u","a","n",0,0,0,0],[0,"b","a","r",0,0,0,0],[0,"c","b","o",0,0,0,0],[0,"e","l","t",0,0,0,0],[0,"r","c","r",0,0,0,0],[0,"e","d","e",0,0,"u","g"],[0,0,"w",0,0,"n",0,0],[0,0,0,"o","p",0,0,0]],
        words: ["celebration","gunpowder","carnival","burst"],
        theme: 'firework',
        colors: colors.red
    },
    {
        layout: [["r","o","d","r","r","o","c"],["h",0,"i",0,0,0,"n"],["t",0,"g","n","i",0,"r"],["a",0,0,0,"d",0,"o"],["p",0,"w","i","n",0,"c"],["h",0,0,0,0,0,"a"],["t","n","i","r","y","b","l"]],
        words: ["labyrinth","winding","corn","path","corridor"],
        theme: 'maze',
        colors: colors.lightblue
    },
    {
        layout: [[0,0,0,0,0,"e","t","h"],[0,0,0,"t","b","i","r",0],[0,0,"o","l","h","a","h",0],[0,"w","g","l","c","e",0,0],[0,"z","e","r","r","e",0,0],["e","m","b","e","o","l","t",0],["e","e","a","c","a","n","d","e"],["c","a","n","r","u","f","g","i"],[0,"k","h","s","i","u","g","n"],[0,"m","o",0,"i","n","x",0],[0,0,"s",0,0,"t",0,0]],
        words: ["smoke","extinguish","furnace","ignite","candle","hearth","blaze","torch","ember","glow"],
        theme: 'fire',
        colors: colors.red
    },
    {
        layout: [[0,0,"e","g","n",0,0],[0,0,"s","i",0,0,0],["o",0,"i","s","o",0,"o"],["e",0,"o","h",0,0,"i"],["r",0,"n","c","e",0,"d"],["e",0,0,0,0,0,"a"],["t","s","a","d","i","o","r"],[0,0,0,"u",0,0,0],[0,0,0,"k",0,0,0],[0,0,"t","a","l",0,0]],
        words: ["talk","audio","noise","stereo","echo","sing","radio"],
        theme: 'microphone',
        colors: colors.red
    },
    {
        layout: [
            [ 0 ,  0 ,  0 , 'o', 'w', 't',  0 ],
            [ 0 ,  0 ,  0 ,  0 ,  0 , 't',  0 ],
            ['o', 'n',  0 , 'e', 'r', 'h',  0 ],
            [ 0 , 'e',  0 , 's',  0 ,  0 ,  0 ],
            [ 0 , 's',  0 , 'e', 'i', 'x',  0 ],
            [ 0 , 'e',  0 ,  0 ,  0 ,  0 ,  0 ],
            ['v', 'e', 'n',  0 , 'f', 'i', 'e'],
            [ 0 ,  0 ,  0 ,  0 ,  0 ,  0 , 'v'],
            [ 0 ,  0 ,  0 ,  0 ,  0 , 'l', 'e'],
            [ 0 ,  0 ,  0 ,  0 ,  0 ,  0 , 'e'],
            [ 0 ,  0 ,  0 ,  0 , 'n', 'e', 'v'],
        ],
        words: ['one', 'seven', 'two', 'three', 'six', 'five', 'eleven'],
        theme: 'numbers',
        colors: colors.black
    },
    {
        layout: [[0,0,"v","c","n","y",0,0],["d","p","a","i","t","r","e","r"],["l",0,"i","t","i","o",0,"n"],["o",0,"p","c","i","n",0,"n"],["g","u","p","a","i","o","w","i"],[0,0,"c","o","r","t",0,0],[0,0,0,"t","e",0,0,0],[0,0,0,"t","m",0,0,0],[0,0,"i","e","t","p",0,0],[0,"g","o","b","l","o","c",0]],
        words: ["winner","cup","competition","goblet","participation","gold","victory"],
        theme: 'trophy',
        colors: colors.yellow
    },
];
*/



/*
ORDERED
*/

let Levels = [
    {
    	layout: [[0,"h",0,"s",0],["a","s","i","c","o"],[0,"h",0,"a",0],["s","m","b","o","l"],[0,"y",0,"l",0]],
    	words: ["symbol","hash","social"],
    	theme: "number",
    	colors: colors.blue,
    },
    {
    	layout: [["l","a","n"],["i","d","l"],[0,"i",0],[0,"u",0],[0,"b",0]],
    	words: ["build","nail"],
    	theme: "hammer",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,"t",0],["x","a","t"],["b",0,0],["d","e","t"],[0,0,"s"],["i","v","e"],[0,"n",0]],
    	words: ["debt","tax","invest"],
    	theme: "money",
    	colors: colors.green,
    },
    {
    	layout: [["k","s","s",0,0,0,0],["c",0,"e","u","i","q","e"],["o",0,"c",0,"n",0,"u"],["l","a","c",0,0,0,0]],
    	words: ["unique","access","lock"],
    	theme: "key",
    	colors: colors.yellow,
    },
    {
    	layout: [["m",0,"s",0,"u",0],[0,"o",0,"q",0,"a"],["v",0,"p",0,"r",0],[0,"e",0,"m",0,"e"],["k",0,"n",0,"u",0],[0,"i",0,"g",0,"j"]],
    	words: ["move","king","square","jump"],
    	theme: "checkers",
    	colors: colors.red,
    },
    {
    	layout: [["l","c","i",0,"i","c","e"],["a",0,"t","v","t",0,"r"],["o","p","e",0,"c","o","r"]],
    	words: ["corrective","optical"],
    	theme: "glasses",
    	colors: colors.lightblue,
    },
    {
    	layout: [["e","n","y","i","g"],["r","e","t","p","n"],["s","c","t","o","p"],[0,0,"k",0,0],[0,"d","e","s",0]],
    	words: ["screen","desktop","typing"],
    	theme: "computer",
    	colors: colors.green,
    },
    {
    	layout: [["e","d"],["s","h"],["n","i"],["t","o"],["a","s"],[0,0],["d","o"],["u","l"]],
    	words: ["astonished","loud"],
    	theme: "exclaim",
    	colors: colors.blue,
    },
    {
    	layout: [["e","s",0,0,0,"t","f"],["i","c","x","e","g","m","i"],["r","e",0,0,0,"y","l"]],
    	words: ["gym","lift","exercise"],
    	theme: "barbell",
    	colors: colors.black,
    },
    {
    	layout: [[0,0,0,"t",0,0,0],[0,0,"g","a","n",0,0],[0,"b","e","p","n","e",0],["t","o","m","y","t","c","i"]],
    	words: ["ancient","egypt","tomb"],
    	theme: "pyramid",
    	colors: colors.yellow,
    },
    {
    	layout: [["t",0,0,"t"],["u",0,0,"s"],["n","t","i","t"],[0,"e","w",0],[0,"k","l",0],[0,"c","o",0],[0,"o","o",0],[0,"s","t",0]],
    	words: ["nut","socket","tool","twist"],
    	theme: "wrench",
    	colors: colors.black,
    },
    {
    	layout: [["r","s","t","e","r","o"],["e",0,0,0,0,"e"],["k",0,0,0,0,"o"],["a","p",0,0,"u","i"],["e","s",0,0,"a","d"]],
    	words: ["audio","stereo","speaker"],
    	theme: "headphones",
    	colors: colors.blue,
    },
    {
    	layout: [[0,"c","z",0],["n","i","l","l"],["e",0,0,"e"],["g",0,0,"c"],["r",0,0,"e"],["a",0,0,"r"],["c","h","w","i"]],
    	words: ["charge","zinc","wire","cell"],
    	theme: "battery",
    	colors: colors.green,
    },
    {
    	layout: [[0,0,"h","o","r",0,0],[0,"i",0,0,0,"p",0],["t",0,"b",0,0,0,"w"],["c",0,0,"i",0,0,"a"],["i",0,0,0,"t",0,"l"],[0,"r",0,0,0,"r",0],[0,0,"t","s","e",0,0]],
    	words: ["prohibit","restrict","law"],
    	theme: "ban",
    	colors: colors.red,
    },
    {
    	layout: [[0,"e","l",0],[0,"i","f",0],[0,0,0,0],["c","a","e",0],[0,"i","t",0],[0,"m","n",0],[0,"m","u",0],[0,"k","o",0],["l","e","a","c"]],
    	words: ["leak","file","communicate"],
    	theme: "information",
    	colors: colors.blue,
    },
    {
    	layout: [[0,0,0,"l",0,0,0],["n",0,"r","e","n",0,"r"],["n","o","c","e","q","u","e"],["w","o","b","u","e","r","l"]],
    	words: ["noble","crown","queen","ruler"],
    	theme: "royalty",
    	colors: colors.yellow,
    },
    {
    	layout: [["y","r","a",0,0,0],["f",0,"l","l",0,0],["a","i","o","c","e",0],[0,"t","t","n","i","d"],[0,0,"t","h","c",0],[0,0,0,"a",0,0]],
    	words: ["attach","identify","collar"],
    	theme: "tag",
    	colors: colors.blue,
    },
    {
    	layout: [[0,0,"r",0,0],[0,0,"e",0,0],[0,0,"b",0,0],[0,0,"b",0,0],[0,0,"u",0,0],[0,0,"r",0,0],[0,0,"m",0,0],[0,"o","o","t",0],["r","t","b","e","l"],["h","a","t","o","i"]],
    	words: ["toilet","bathroom","rubber"],
    	theme: "plunger",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,0,"f","a",0,0,0],[0,0,0,"l","h",0,0,0],[0,0,0,0,0,0,0,0],["e","a","a","m","s","y","l","p"],["t","r","p","e","u","l","t","i"],[0,0,0,0,0,0,0,0],[0,0,0,"o","r",0,0,0],[0,0,0,"z","e",0,0,0]],
    	words: ["half","zero","multiply","separate"],
    	theme: "divide",
    	colors: colors.lightblue,
    },
    {
    	layout: [["r",0,0,"m"],["e","t","b","i"],["h",0,0,"l"],["g","i","g","c"],["f",0,0,"n"],["e","i","f","u"],["r",0,0,"r"]],
    	words: ["firefighter","rung","climb"],
    	theme: "ladder",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,"n","a","c","a","i",0],["e","i","k","r","n","t","r"],[0,"m","e","c","a","l",0],[0,0,"e","n","k",0,0],[0,0,0,"g",0,0,0]],
    	words: ["ring","mine","karat","necklace"],
    	theme: "diamond",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,0,0,"b",0,0,0],[0,0,0,"u",0,0,0],[0,0,"s","h","r",0,0],[0,0,0,"m",0,0,0],[0,"s","a","p","l","e",0],[0,0,0,"i",0,0,0],["e","g","a","l","k","a","o"],[0,0,0,"o",0,0,0],[0,0,0,"f",0,0,0]],
    	words: ["oak","foliage","sap","shrub","elm"],
    	theme: "tree",
    	colors: colors.green,
    },
    {
    	layout: [["g","n","t",0,0,"e"],[0,"i","a",0,"e","z"],[0,0,"l","e","r","b"],["c","l","g","n",0,0],["s","i",0,"l","i",0],["o",0,0,"o","o","c"]],
    	words: ["cooling","oscillating","breeze"],
    	theme: "fan",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,0,0,"i",0,0,0],[0,0,0,"w","n",0,0],[0,0,0,"g","t","d",0],[0,0,0,"t","s","a","m"],[0,0,0,"a",0,0,0],["p","r","r","o","b","a","t"],[0,"o","e","t","a","t",0]],
    	words: ["regatta","port","boat","mast","wind"],
    	theme: "sailing",
    	colors: colors.blue,
    },
    {
    	layout: [[0,0,0,"m","i","p",0,0],[0,0,0,"i",0,"l",0,0],[0,0,0,"r","g","c",0,0],["r","o","t",0,"n",0,0,0],["l",0,"t","r","i","w","e","s"],["i","a","p",0,"a",0,0,0],[0,0,0,0,"h",0,0,0],[0,0,0,0,"s",0,0,0]],
    	words: ["tailor","clip","sharp","trim","sewing"],
    	theme: "scissors",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,0,"g","e","t",0,0],[0,0,"r",0,0,0,0],["t","a","e","d","i","l","s"],[0,0,0,0,0,0,0],["i","c","e","e","t","o","s"],[0,"m","a","e","n","t",0]],
    	words: ["ice","team","slide","target","stone"],
    	theme: "curling",
    	colors: colors.blue,
    },
    {
    	layout: [["t","n","a","s","n","o","c"],[0,0,"t",0,"r",0,0],[0,0,"e",0,"e",0,0],[0,0,"l",0,"t",0,0],[0,0,"c",0,"e",0,"i"],["c","i","r",0,"m","a","d"]],
    	words: ["circle","diameter","constant"],
    	theme: "pi",
    	colors: colors.green,
    },
    {
    	layout: [[0,"w","s","d","s",0],["e","n","u","u","l","c"],["t","u","g","o","n","u"],["s",0,"f","o",0,"o"],[0,0,"s","o",0,0],[0,0,"i","p",0,0]],
    	words: ["poisonous","cloud","stew","fungus"],
    	theme: "mushroom",
    	colors: colors.yellow,
    },
    {
    	layout: [["e",0,0,0,0,0],["l","s","t","y",0,0],["o","i","r","h","m","t"],["p","t","o","a","e","s"],["n",0,0,"w","v","a"],["u",0,0,0,0,0],["o",0,0,0,0,0],["c",0,0,0,0,0]],
    	words: ["mast","wave","hoist","country","pole"],
    	theme: "flag",
    	colors: colors.lightblue,
    },
    {
    	layout: [["e",0,"h",0,"c","h","i","n"],["l","o","w",0,"t","w","e","a"],[0,"o",0,0,"a","f","c","o"],[0,"b","l","n","i","l","t","a"]],
    	words: ["fin","watch","blowhole","tail","ocean"],
    	theme: "whale",
    	colors: colors.blue,
    },
    {
    	layout: [["p","a","y","e","l","a","s"],[0,0,0,0,0,0,0],["e","r","d","t","b","e","e"],["b",0,0,"u",0,"d","e"],["m","u","n","a","r","f","f"]],
    	words: ["number","sale","fee","fraud","debt","pay"],
    	theme: "credit card",
    	colors: colors.lightblue,
    },
    {
    	layout: [["k","a","e"],["d",0,"r"],["u","n","b"],[0,"o",0],["n","k","b"],["i",0,"n"],["l","r","o"],[0,"i",0],["l","a","j"],["i",0,"f"],["c","u","f"]],
    	words: ["cuff","jail","link","iron","bound","break"],
    	theme: "chain",
    	colors: colors.black,
    },
    {
    	layout: [[0,"n","h","b","t",0],["p","u","u","c","k","e"],[0,0,0,0,0,0],["c","h","e","e","s","e"],[0,0,0,0,0,0],["l","d","i","n","e","r"],[0,"l","i","r","g",0]],
    	words: ["grill","diner","ketchup","cheese","bun"],
    	theme: "hamburger",
    	colors: colors.green,
    },
    {
    	layout: [[0,0,"n","l","i",0,0],[0,0,"i",0,"a",0,0],[0,0,"h","a","s",0,0],[0,0,0,"c",0,0,0],[0,0,"i","p","s",0,0],["e",0,0,"h",0,0,"y"],["o","r",0,"e",0,"u","o"],[0,"h","s","p","o","b",0],[0,0,0,"r",0,0,0]],
    	words: ["shore","rope","ship","sail","buoy","chain"],
    	theme: "anchor",
    	colors: colors.blue,
    },
    {
    	layout: [[0,0,"p","y",0,0],[0,0,"i","o",0,0],["e","l","h","f","w","a"],["b","s","r","h","i","f"],[0,0,"i","t",0,0],[0,0,"g","e",0,0],[0,0,"l","o",0,0],[0,0,"e","o",0,0],[0,0,"t","h",0,0]],
    	words: ["theology","belief","worship","faith"],
    	theme: "religion",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,0,"n",0,0],[0,0,"m",0,0],[0,"w","e","a",0],[0,"e","t","r",0],["n","d","u","s","p"],["i","e","s","o","a"],["a","h","r","o","v"],[0,"t","o","f",0]],
    	words: ["fountain","hose","stream","vapor","dew"],
    	theme: "water",
    	colors: colors.blue,
    },
    {
    	layout: [[0,0,0,0,"o","c",0,0],[0,0,0,0,"e","t","o",0],[0,0,0,0,"s",0,0,"n"],[0,0,0,0,"i",0,0,0],[0,0,0,0,"d",0,0,0],[0,0,0,0,"j",0,0,0],[0,"z","r","e","l",0,0,0],["l","s","z","a","a",0,0,0],["c","a","s","g","c",0,0,0],[0,"e","n","i",0,0,0,0]],
    	words: ["genre","jazz","classical","disco","note"],
    	theme: "music",
    	colors: colors.black,
    },
    {
    	layout: [["n","i","t","i","n"],[0,"y","e","p",0],[0,"a","l","r",0],[0,"l","l","u",0],["p","s","b","p","e"],["i","d","g","p","a"],[0,0,"n",0,0],[0,0,"a",0,0],[0,0,"h",0,0]],
    	words: ["display","paper","pin","hang","bulletin"],
    	theme: "thumbtack",
    	colors: colors.red,
    },
    {
    	layout: [[0,"y","c","n","u","s",0],["p","e","l","o","t","e","o"],["o","a","n","i","c","t","r"],["n",0,0,"b",0,0,"p"],[0,0,0,"a",0,0,0],[0,0,0,"d",0,0,0],[0,0,0,"l",0,0,0],[0,0,"f","o",0,0,0]],
    	words: ["canopy","foldable","sun","protection"],
    	theme: "umbrella",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,"e","r",0,"l","u",0],["o","d","t","o","o","s","o"],["w","o","a","d","n","v","l"],[0,"e","a","o","e","p",0],[0,0,"i","s","a",0,0],[0,0,0,"s",0,0,0]],
    	words: ["passion","adore","soul","date","woo","love"],
    	theme: "heart",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,"t","l","a","n","i"],[0,0,"c",0,0,0,"g"],["n","e","x","a","y",0,"i"],["i",0,0,0,"p",0,"r"],["w",0,0,0,"o","m","o"],["t",0,0,0,"u",0,0],["e","t","a","t","c",0,0]],
    	words: ["original","copy","exact","mutate","twin"],
    	theme: "clone",
    	colors: colors.blue,
    },
    {
    	layout: [[0,"y",0,0,"e",0],[0,"t",0,0,"g",0],[0,"r",0,0,"a",0],["i","r","d","c","t","v"],["c","t","o","l","o","o"],["i","e","l","t","u","e"],[0,"t","c","e","l",0]],
    	words: ["cord","electricity","outlet","voltage"],
    	theme: "plug",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,0,"e",0,0],[0,"a","c","t",0],["p","s","e","a","u"],[0,"f",0,"l",0],[0,"f","t","n",0],[0,"o","t","o",0],[0,"e","u","r",0],["a","k","h","a","t"],["t",0,"s",0,"s"]],
    	words: ["takeoff","space","astronaut","shuttle"],
    	theme: "rocket",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,0,"o","w","t",0],[0,0,0,0,0,"t",0],["o","n",0,"e","r","h",0],[0,"e",0,"s",0,0,0],[0,"s",0,"e","i","x",0],[0,"e",0,0,0,0,0],["v","e","n",0,"f","i","e"],[0,0,0,0,0,0,"v"],[0,0,0,0,0,"l","e"],[0,0,0,0,0,0,"e"],[0,0,0,0,"n","e","v"]],
    	words: ["one","seven","two","three","six","five","eleven"],
    	theme: "numbers",
    	colors: colors.black,
    },
    {
    	layout: [["c","h","e","r","r","o","t"],["t",0,0,0,0,0,"c"],["e",0,0,"s",0,0,"o"],["r",0,"e","r","n",0,"d"],["t",0,0,"u",0,0,"y"],["s",0,0,0,0,0,"r"],["i","n","f","i","r","m","a"]],
    	words: ["nurse","infirmary","stretcher","doctor"],
    	theme: "medic",
    	colors: colors.red,
    },
    {
    	layout: [[0,"w","a","s","t","e",0],[0,0,0,0,0,0,0],["c","r","n","l","e","l","a"],[0,"a",0,"c",0,"s",0],[0,"e",0,"y",0,"o",0],[0,"t",0,"c",0,"p",0],[0,"t",0,"e",0,"s",0],[0,"l","i","r","i","d",0]],
    	words: ["recycle","disposal","litter","waste","can"],
    	theme: "trash",
    	colors: colors.black,
    },
    {
    	layout: [[0,"n","e","s","e",0],[0,"e",0,0,"a",0],["g","g","g","n","c","t"],["g","a","i","l","a","i"],["a","k","c","r","p","u"],["b","a","p","a","i","s"]],
    	words: ["airplane","packing","baggage","suitcase"],
    	theme: "luggage",
    	colors: colors.blue,
    },
    {
    	layout: [["r","m","e","e",0,0],["e","r","c","f","f","r"],["d","w","a","o",0,"e"],["i","n","g","i",0,"h"],["t","e","i","p","t","c"],["c","s","a","m",0,0]],
    	words: ["cider","pitcher","steaming","coffee","warm"],
    	theme: "mug",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,0,"o","y","d",0,0],[0,0,"s","n","o",0,0],[0,0,"p","r","b",0,0],[0,0,0,"e",0,0,0],["p","r","i","m","a","t","e"],[0,0,0,"l",0,0,0],[0,0,0,"s",0,0,0],[0,0,"i","e","a",0,0],[0,0,"c",0,"m",0,0],[0,0,"e",0,"m",0,0],[0,"s","p",0,"a","m",0]],
    	words: ["mammal","species","primate","person","body"],
    	theme: "human",
    	colors: colors.green,
    },
    {
    	layout: [[0,0,"l","f","z","o",0,0],["o","m","i",0,0,"o","m","e"],["t",0,0,0,0,0,0,"r"],["o",0,0,"e","s",0,0,"u"],["h",0,0,"l","n",0,0,"s"],["p",0,0,0,0,0,0,"o"],["l","a","c","o","f","e","x","p"]],
    	words: ["film","focal","zoom","lens","exposure","photo"],
    	theme: "camera",
    	colors: colors.lightblue,
    },
    {
    	layout: [["s","p","s","r","d"],["e","i","s","y","a"],["t","l","a","n","e"],["o","t","l","v","i"],[0,"b","g","g",0],[0,0,"n",0,0],[0,0,"i",0,0],[0,0,"t",0,0],[0,"s","a","t",0]],
    	words: ["bottle","vineyard","tasting","sip","glass"],
    	theme: "wine",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,0,"b",0,0,0],[0,0,"r","m","n",0,0],[0,"y","o","i","i","t",0],["s","k","t","l","a","u","n"],[0,0,"a","c","o",0,0],[0,0,"v","n","m",0,0],[0,0,"e","w","y",0,0],[0,0,"l","o","l",0,0],[0,0,"e","d","f",0,0]],
    	words: ["down","fly","sky","climb","elevator","mountain"],
    	theme: "up",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,0,"m","r","e",0,0],[0,"g","i","e","l","l",0],[0,"n","c","i","g","e",0],[0,"o","o","h","n","p",0],[0,"m","u","n","i","a",0],["g","m","n","s","j","c","h"],[0,0,0,"g",0,0,0]],
    	words: ["chapel","gong","jingle","summon","chime","ring"],
    	theme: "bell",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,0,0,"t",0,0,0],[0,0,"n","c","e",0,0],[0,"r","a","e","u","o",0],["s","e","l","l","e","r","r"],[0,"u",0,"d",0,"s",0],[0,"p",0,"a",0,"s",0],[0,"m",0,"r",0,"e",0],["c","a","g","p","r","o","f"]],
    	words: ["campus","professor","learn","lecture","grade"],
    	theme: "university",
    	colors: colors.red,
    },
    {
    	layout: [["a","n","g","d","y","y","o"],["t","n","i","o","l","n","h"],["a",0,"u",0,"e",0,"p"],["n",0,"t",0,"m",0,"m"],["o",0,0,0,0,0,"y"],["s","d","n","a","r","g","s"]],
    	words: ["grand","melody","symphony","sonata","tuning"],
    	theme: "piano",
    	colors: colors.black,
    },
    {
    	layout: [["m","i","a","w","o","r","r"],["e",0,0,0,0,0,"a"],["c",0,"b","u","l",0,"y"],["i",0,"e",0,"l",0,"c"],["t",0,"y","e","s",0,"a"],["c",0,0,0,0,0,"r"],["a","r","p","a","c","c","u"]],
    	words: ["practice","accuracy","arrow","aim","bullseye"],
    	theme: "target",
    	colors: colors.red,
    },
    {
    	layout: [["i",0,0,0,"u","t","r",0],["w","m",0,"a","u","o","c","t"],["s","l","s","a","l","m","o","n"],["l","g",0,"n","t","o","t","b"],["i",0,0,0,"d","i","a",0]],
    	words: ["tuna","cod","gill","swim","bait","salmon","trout"],
    	theme: "fish",
    	colors: colors.blue,
    },
    {
    	layout: [[0,"c","i","e",0],["d","i",0,"n","e"],["e",0,0,0,"l"],["m",0,0,0,"o"],["e",0,0,0,"b"],["s","d","c","e","u"],["o","a","p",0,"s"],["n","l","v",0,"p"],["i","m",0,"i","a"],[0,"a","t","c",0]],
    	words: ["dose","capsule","vitamin","medicine","placebo"],
    	theme: "pill",
    	colors: colors.red,
    },
    {
    	layout: [["t","s","i","t","e","w","e"],["u",0,0,"d",0,0,"i"],["o",0,0,"h",0,0,"v"],["a","s","s","g","s","u","e"],["l",0,0,"i",0,0,"n"],["g",0,0,"l",0,0,"n"],["e","m","a","r","f","p","a"]],
    	words: ["frame","pane","sun","view","glass","light","outside"],
    	theme: "window",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,0,"l",0,0,0,0,0],[0,"t","n","a",0,0,0,0],["r","s","i","v","i",0,0,0],[0,"u","a","n",0,0,0,0],[0,"b","a","r",0,0,0,0],[0,"c","b","o",0,0,0,0],[0,"e","l","t",0,0,0,0],[0,"r","c","r",0,0,0,0],[0,"e","d","e",0,0,"u","g"],[0,0,"w",0,0,"n",0,0],[0,0,0,"o","p",0,0,0]],
    	words: ["celebration","gunpowder","carnival","burst"],
    	theme: "firework",
    	colors: colors.red,
    },
    {
    	layout: [[0,"s","e","e","o","r",0],["r","i","c","i","e","k","a"],["e","r","l","s","l","u","b"],[0,"t","t","l","n","f",0],[0,"t","u","e","a","t",0],[0,"u","l","l","e","s",0],[0,"b","o","r","g","y",0]],
    	words: ["roll","gluten","slice","yeast","butter","flour","rise","bake"],
    	theme: "bread",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,"a","y",0,"e","t",0],["l","n","r","e","h","i","s"],["e","i","f","t","c","n","t"],["m","a","h","i","a","d","e"],[0,"t","u","b","r","p",0],[0,"o","m",0,"a","s",0],[0,0,"e",0,"h",0,0]],
    	words: ["bite","sharp","enamel","ache","mouth","dentist","fairy"],
    	theme: "tooth",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,0,"e","g","n",0,0],[0,0,"s","i",0,0,0],["o",0,"i","s","o",0,"o"],["e",0,"o","h",0,0,"i"],["r",0,"n","c","e",0,"d"],["e",0,0,0,0,0,"a"],["t","s","a","d","i","o","r"],[0,0,0,"u",0,0,0],[0,0,0,"k",0,0,0],[0,0,"t","a","l",0,0]],
    	words: ["talk","audio","noise","stereo","echo","sing","radio"],
    	theme: "microphone",
    	colors: colors.red,
    },
    {
    	layout: [["t",0,"p",0,"n"],["i","z","h","u","e"],["l","b","b","q","e"],[0,"n","k","o",0],[0,"o","o","r",0],[0,"e","c","t",0],[0,"s","h","g",0],["k","i","i","n","k"],["c","h","w","a","p"]],
    	words: ["pawn","check","bishop","blitz","rook","knight","queen"],
    	theme: "chess",
    	colors: colors.yellow,
    },
    {
    	layout: [["a","l","k","c","a","r","c","y"],["w",0,"l",0,0,0,0,"e"],["e",0,"i",0,0,0,0,"n"],["c","u","b","l","d","d","e","m"],["a",0,0,0,0,"a",0,"i"],["l",0,0,0,0,"c",0,"h"],["p","e","r","i","f","f","a","c"]],
    	words: ["build","fireplace","facade","wall","crack","chimney"],
    	theme: "brick",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,0,"c",0,0,0],[0,0,"k",0,"i",0,0],[0,"d",0,0,0,"l",0],["n",0,0,0,0,0,"r"],["e","a",0,0,0,"p","e"],["s","s","l",0,"l","t","t"],["t","m","e","a","i","e","l"],["s","a","p","m","a","l","f"]],
    	words: ["lick","seal","stamp","mail","flap","letter","send"],
    	theme: "envelope",
    	colors: colors.lightblue,
    },
    {
    	layout: [["c","h","p","a","r","g","y"],["e",0,0,0,0,0,"l"],["i","d","i","v","t","i","p"],["t",0,"i",0,"l",0,"t"],["e","d","d","a","u",0,"i"],["m",0,"d",0,"m",0,"g"],["h","t","i","r","a","d","i"]],
    	words: ["digit","arithmetic","graph","add","divide","multiply"],
    	theme: "calculator",
    	colors: colors.blue,
    },
    {
    	layout: [[0,"b","o","l","c",0],[0,"t",0,0,"t",0],[0,"e",0,0,"p",0],["s","r","e","l","e","k"],["u","e","u","n","k","c"],["s","f","c","s","a","i"],["a","t","s","h","r","e"],["r","s","y","p","l","i"]],
    	words: ["pliers","pick","shackle","rusty","fasten","secure","bolt"],
    	theme: "lock",
    	colors: colors.yellow,
    },
    {
    	layout: [["r","o","d","r","r","o","c"],["h",0,"i",0,0,0,"n"],["t",0,"g","n","i",0,"r"],["a",0,0,0,"d",0,"o"],["p",0,"w","i","n",0,"c"],["h",0,0,0,0,0,"a"],["t","n","i","r","y","b","l"]],
    	words: ["labyrinth","winding","corn","path","corridor"],
    	theme: "maze",
    	colors: colors.lightblue,
    },
    {
    	layout: [[0,"t",0,0,0,"a",0],["n","n","o","i","t","c","a"],["e",0,0,0,0,0,"v"],["v","u","l","e","k","a","y"],["d",0,"d",0,"e",0,"d"],["a","h","e","w","e","l","i"],["a",0,"c",0,"t",0,"o"],["d","y","s","e","d","a","h"]],
    	words: ["date","holiday","vacation","day","advent","week","schedule"],
    	theme: "calendar",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,"s","m","k","i","n"],[0,0,"e","u","a","r","a"],[0,"z","d","s","e","r",0],[0,"t","u","y","t",0,0],["o","l","r","o","s","c","c"],["b","o","t","t","l","l",0],[0,0,"c","i","a",0,0],[0,"t","i","p",0,0,0],[0,"c","r",0,0,0,0],["l","e",0,0,0,0,0],["e",0,0,0,0,0,0]],
    	words: ["electricity","storm","clap","bolt","zeus","rain","cloud","streak"],
    	theme: "lightning",
    	colors: colors.yellow,
    },
    {
    	layout: [[0,"t","e","t","n","e",0],["h","a","d","e","o","t","a"],["o",0,0,"l",0,0,"r"],["o",0,0,"e",0,0,"i"],["t","e","k",0,"p","y","p"],["t","t","s","b","e","n","k"],[0,"a","a","s","o","o",0],[0,"h",0,"d",0,"o",0]],
    	words: ["head","skeleton","spooky","bone","pirate","tattoo","death"],
    	theme: "skull",
    	colors: colors.black,
    },
    {
    	layout: [[0,0,0,0,0,"e","t","h"],[0,0,0,"t","b","i","r",0],[0,0,"o","l","h","a","h",0],[0,"w","g","l","c","e",0,0],[0,"z","e","r","r","e",0,0],["e","m","b","e","o","l","t",0],["e","e","a","c","a","n","d","e"],["c","a","n","r","u","f","g","i"],[0,"k","h","s","i","u","g","n"],[0,"m","o",0,"i","n","x",0],[0,0,"s",0,0,"t",0,0]],
    	words: ["smoke","extinguish","furnace","ignite","candle","hearth","blaze","torch","ember","glow"],
    	theme: "fire",
    	colors: colors.red,
    },
    {
    	layout: [[0,0,"v","c","n","y",0,0],["d","p","a","i","t","r","e","r"],["l",0,"i","t","i","o",0,"n"],["o",0,"p","c","i","n",0,"n"],["g","u","p","a","i","o","w","i"],[0,0,"c","o","r","t",0,0],[0,0,0,"t","e",0,0,0],[0,0,0,"t","m",0,0,0],[0,0,"i","e","t","p",0,0],[0,"g","o","b","l","o","c",0]],
    	words: ["winner","cup","competition","goblet","participation","gold","victory"],
    	theme: "trophy",
    	colors: colors.yellow,
    },
]

/*
let levels = [...Levels];
levels.sort((a, b) => {
    let aSize = 0;
    let bSize = 0;
    for (let i = 0; i < a.words.length; i++) {
        aSize += a.words[i].length;
    }
    for (let i = 0; i < b.words.length; i++) {
        bSize += b.words[i].length;
    }
    return aSize - bSize;
});
Levels = [...levels];
console.log(Levels);

let str = '';
for (let i = 0; i < Levels.length; i++) {
    str += '{\n';
    str += '\tlayout: ' + JSON.stringify(Levels[i].layout) + ',\n';
    str += '\twords: ' + JSON.stringify(Levels[i].words) + ',\n';
    str += '\ttheme: ' + JSON.stringify(Levels[i].theme) + ',\n';
    str += '\tcolors: colors.' + Levels[i].colors + ',\n';
    str += '},\n';
}
console.log(str);
*/



export default Levels;
